import React from 'react';

function stringifyAnswer(response) {
  const values = [];

  response.answer.forEach((answer, index) => {
    for (let valueType in answer) {
      if (valueType === 'valueBoolean') {
        values.push(answer.valueString === true ? 'Yes' : 'No');
      } else {
        values.push(answer[valueType]);
      }
    }
  });

  return values.join(', ');
}

export default function HPIQuestions({ questions, answers }) {
  const HPIquestions = questions.filter((item) => {
    const isNote = item.extension.find((extension) => {
      return extension.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note' &&
        extension.valueBoolean;
    })

    return isNote;
  });

  if (HPIquestions.length > 0) {
    return <>
      {HPIquestions.map((question, i) => {
        const response = answers.find((item) => {
          return item.linkId === question.linkId;
        });

        return <p key={i}><strong>{question.text}</strong> {!response ? 'None Provided' : stringifyAnswer(response)}</p>
      })}
    </>;
  } else {
    return <div className='text-center'>No Summary Available</div>
  }

}